/**
 * Appends `dietitian_portal_redirect_to=<encoded>` to a Season URL when a
 * captured value is pending. No-op when redirectTo is null/empty/undefined,
 * or when the URL is malformed.
 *
 * Centralized so both AsyncLinkInterceptor (direct-click) and usePartnerRedirect
 * (auto-redirect after login) share the same append logic.
 */
export const appendRedirectQueryParam = (url: string, redirectTo: string | null | undefined): string => {
  if (!redirectTo) return url;
  try {
    const u = new URL(url);
    u.searchParams.append("dietitian_portal_redirect_to", redirectTo);
    return u.toString();
  } catch {
    return url;
  }
};
